


/**
 * 设置导航栏
 * @param {Record<string, any} param 参数
 * @returns 
 */
function setNavbar(param) {
  return new Promise(resolve => {
    _tc_bridge_bar.set_navbar({
      param,
      callback(data) {
          resolve(JSON.parse(data.cbObj))
      }
    })
  })
}

/**
 * 修改标题
 * @param {string} title 标题
 */
export function changeTitle(title) {
  document.title = title
  // 修改导航栏标题
  setNavbar({
    center: [{
      value: title
    }]
  })
}